/*
 * Carte de la section livraison : des lignes partent de l'atelier de Vitré vers
 * des communes tirées au sort. Simulation décorative, pas de vraies commandes.
 * Les contours viennent de snippets/sl-europe-map.liquid (Natural Earth, domaine public,
 * projection conique de Lambert : ses paramètres sont dans data-proj du SVG).
 */
(() => {
  const WORKSHOP = { name: 'Vitré', lat: 48.1176, lng: -1.2063 };
  const SVG_NS = 'http://www.w3.org/2000/svg';
  const VIEW_W = 1000;
  const VIEW_H = 800;

  const DRAW_MS = 1400;
  const LABEL_MS = 3400;
  const FADE_MS = 700;
  const SPAWN_MIN_MS = 750;
  const SPAWN_MAX_MS = 1350;
  const RECENT_LIMIT = 8;

  // [nom, lat, lng]
  const FR_BIG = [
    ['Paris', 48.8566, 2.3522], ['Lyon', 45.764, 4.8357], ['Marseille', 43.2965, 5.3698],
    ['Toulouse', 43.6047, 1.4442], ['Nantes', 47.2184, -1.5536], ['Bordeaux', 44.8378, -0.5792],
    ['Lille', 50.6292, 3.0573], ['Rennes', 48.1173, -1.6778], ['Strasbourg', 48.5734, 7.7521],
    ['Nice', 43.7102, 7.262], ['Montpellier', 43.6108, 3.8767], ['Grenoble', 45.1885, 5.7245],
  ];
  const FR_MID = [
    ['Rouen', 49.4432, 1.0993], ['Dijon', 47.322, 5.0415], ['Angers', 47.4784, -0.5632],
    ['Tours', 47.3941, 0.6848], ['Reims', 49.2583, 4.0317], ['Le Mans', 48.0061, 0.1996],
    ['Brest', 48.3904, -4.4861], ['Clermont-Ferrand', 45.7772, 3.087], ['Metz', 49.1193, 6.1757],
    ['Orléans', 47.9029, 1.9093], ['Caen', 49.1829, -0.3707], ['Limoges', 45.8336, 1.2611],
    ['Poitiers', 46.5802, 0.3404], ['Nancy', 48.6921, 6.1844], ['Perpignan', 42.6887, 2.8948],
    ['Amiens', 49.8941, 2.2957], ['Besançon', 47.2378, 6.0241], ['Annecy', 45.8992, 6.1294],
    ['Lorient', 47.7482, -3.3702], ['Quimper', 47.996, -4.1024], ['Saint-Malo', 48.6493, -2.0257],
    ['Laval', 48.0698, -0.7707], ['La Rochelle', 46.1603, -1.1511], ['Pau', 43.2951, -0.3708],
    ['Avignon', 43.9493, 4.8055], ['Nîmes', 43.8367, 4.3601], ['Mulhouse', 47.7508, 7.3359],
    ['Bayonne', 43.4929, -1.4748], ['Valence', 44.9334, 4.8924], ['Cholet', 47.06, -0.8796],
    ['Dunkerque', 51.0343, 2.3768], ['Colmar', 48.0794, 7.3585],
  ];
  const FR_SMALL = [
    ['Fougères', 48.3523, -1.2], ['Ploërmel', 47.9322, -2.3969], ['Landerneau', 48.4515, -4.2494],
    ['Pontivy', 48.0674, -2.9649], ['Mayenne', 48.3047, -0.6139], ['Segré', 47.6867, -0.8736],
    ['Auray', 47.6686, -2.9814], ['Thouars', 46.9778, -0.2153], ['Montargis', 47.9979, 2.7331],
    ['Sarlat-la-Canéda', 44.8896, 1.2166], ['Bagnères-de-Bigorre', 43.0653, 0.1492],
    ['Barcelonnette', 44.3862, 6.6526], ['Briançon', 44.8996, 6.6372], ['Digne-les-Bains', 44.0919, 6.2358],
    ['Saint-Flour', 45.0343, 3.0914], ['Guéret', 46.1703, 1.8717], ['Le Puy-en-Velay', 45.0428, 3.8859],
    ['Autun', 46.9514, 4.2993], ['Cambrai', 50.1737, 3.2358], ['Millau', 44.0986, 3.0777],
    ['Aurillac', 44.9264, 2.4399], ['Cahors', 44.4475, 1.4417], ['Albi', 43.9298, 2.148],
    ['Épinal', 48.1724, 6.4503], ['Gap', 44.5594, 6.0786], ['Biarritz', 43.4832, -1.5586],
    ['Chartres', 48.4469, 1.489], ['Saintes', 45.7456, -0.6322], ['Niort', 46.3238, -0.4588],
    ['Béziers', 43.3441, 3.2158], ['Charleville-Mézières', 49.7623, 4.7197], ['Montluçon', 46.3407, 2.603],
    ['Vierzon', 47.2225, 2.0687], ['Avranches', 48.6843, -1.3577], ['Granville', 48.8387, -1.5974],
    ['Paimpont', 47.9807, -2.1627],
  ];
  const BELGIUM = [
    ['Bruxelles', 50.8503, 4.3517], ['Anvers', 51.2194, 4.4025], ['Liège', 50.6326, 5.5797],
    ['Gand', 51.0543, 3.7174], ['Charleroi', 50.4108, 4.4446], ['Namur', 50.4674, 4.8719],
    ['Bruges', 51.2093, 3.2247], ['Mons', 50.4542, 3.9523], ['Louvain', 50.8798, 4.7005],
    ['Tournai', 50.6056, 3.3878], ['Arlon', 49.6833, 5.8167], ['Spa', 50.4924, 5.8628],
    ['Wavre', 50.7167, 4.6], ['Dinant', 50.2603, 4.9119], ['Ostende', 51.2154, 2.9287],
  ];
  const WEST = [
    ['Amsterdam', 52.3676, 4.9041], ['Rotterdam', 51.9244, 4.4777], ['Utrecht', 52.0907, 5.1214],
    ['Luxembourg', 49.6116, 6.1319], 
    ['Cologne', 50.9375, 6.9603],
    ['Francfort', 50.1109, 8.6821], ['Stuttgart', 48.7758, 9.1829], ['Munich', 48.1351, 11.582],
    ['Hambourg', 53.5511, 9.9937], ['Madrid', 40.4168, -3.7038], ['Barcelone', 41.3874, 2.1686],
    ['València', 39.4699, -0.3763], ['Bilbao', 43.263, -2.935], ['Lisbonne', 38.7223, -9.1393],
    ['Porto', 41.1579, -8.6291], ['Milan', 45.4642, 9.19], ['Turin', 45.0703, 7.6869],
    ['Rome', 41.9028, 12.4964], ['Florence', 43.7696, 11.2558], 
    ['Dublin', 53.3498, -6.2603], ['Aix-la-Chapelle', 50.7753, 6.0839],
  ];
  const FAR = [
    ['Vienne', 48.2082, 16.3738], ['Prague', 50.0755, 14.4378], ['Varsovie', 52.2297, 21.0122],
    ['Cracovie', 50.0647, 19.945], ['Budapest', 47.4979, 19.0402], ['Copenhague', 55.6761, 12.5683],
    ['Zagreb', 45.815, 15.9819], ['Split', 43.5081, 16.4402], ['Bratislava', 48.1486, 17.1077],
    ['Ljubljana', 46.0569, 14.5058], ['Berlin', 52.52, 13.405],
  ];

  // Poids par zone, puis par taille de commune : les petites villes comptent
  // autant que les grandes, sinon on ne verrait que Paris, Lyon et Marseille.
  const ZONES = [
    { weight: 0.6, tiers: [{ weight: 0.28, list: FR_BIG }, { weight: 0.4, list: FR_MID }, { weight: 0.32, list: FR_SMALL }] },
    { weight: 0.16, tiers: [{ weight: 1, list: BELGIUM }] },
    { weight: 0.16, tiers: [{ weight: 1, list: WEST }] },
    { weight: 0.08, tiers: [{ weight: 1, list: FAR }] },
  ];

  const recent = [];

  const pickWeighted = (items) => {
    let roll = Math.random() * items.reduce((sum, item) => sum + item.weight, 0);
    for (const item of items) {
      roll -= item.weight;
      if (roll <= 0) return item;
    }
    return items[items.length - 1];
  };

  const pickDestination = () => {
    for (let attempt = 0; attempt < 6; attempt += 1) {
      const list = pickWeighted(pickWeighted(ZONES).tiers).list;
      const [name, lat, lng] = list[Math.floor(Math.random() * list.length)];
      if (!recent.includes(name)) {
        recent.push(name);
        if (recent.length > RECENT_LIMIT) recent.shift();
        return { name, lat, lng };
      }
    }
    return null;
  };

  const el = (name, attrs = {}) => {
    const node = document.createElementNS(SVG_NS, name);
    Object.entries(attrs).forEach(([key, value]) => node.setAttribute(key, String(value)));
    return node;
  };

  const init = (root) => {
    const svg = root.querySelector('.sl-eu');
    const routes = svg && svg.querySelector('.sl-eu__routes');
    const points = svg && svg.querySelector('.sl-eu__points');
    if (!routes || !points) return;

    const proj = JSON.parse(svg.dataset.proj);
    const project = (lat, lng) => {
      const phi = (lat * Math.PI) / 180;
      const rho = proj.f / Math.tan(Math.PI / 4 + phi / 2) ** proj.n;
      const theta = proj.n * ((lng * Math.PI) / 180 - proj.l0);
      return { x: proj.tx + proj.s * rho * Math.sin(theta), y: proj.ty - proj.s * (proj.r0 - rho * Math.cos(theta)) };
    };

    // Le SVG est en "slice" : selon le conteneur, une partie du cadre est rognée.
    const view = { scale: 1, x0: 0, y0: 0, w: VIEW_W, h: VIEW_H };
    const measure = () => {
      const box = svg.getBoundingClientRect();
      if (!box.width || !box.height) return;
      view.scale = Math.max(box.width / VIEW_W, box.height / VIEW_H);
      view.w = box.width / view.scale;
      view.h = box.height / view.scale;
      view.x0 = (VIEW_W - view.w) / 2;
      view.y0 = (VIEW_H - view.h) / 2;
    };
    const inView = (point, pad) =>
      point.x > view.x0 + pad && point.x < view.x0 + view.w - pad && point.y > view.y0 + pad && point.y < view.y0 + view.h - pad;
    const px = (n) => n / view.scale;

    const workshop = project(WORKSHOP.lat, WORKSHOP.lng);

    const drawWorkshop = () => {
      points.querySelectorAll('.sl-eu__workshop').forEach((node) => node.remove());
      const g = el('g', { class: 'sl-eu__workshop', transform: 'translate(' + workshop.x + ' ' + workshop.y + ')' });
      const k = px(1);
      const inner = el('g', { transform: 'scale(' + k + ')' });
      inner.append(
        el('circle', { class: 'sl-eu__pulse', r: 16 }),
        el('path', { class: 'sl-eu__pin', d: 'M0 0C-9-10-13-17-13-24a13 13 0 0 1 26 0C13-17 9-10 0 0z' }),
        el('circle', { class: 'sl-eu__pin-eye', cy: -24, r: 4.6 }),
      );
      const label = el('g', { class: 'sl-eu__tag', transform: 'translate(-20 -22)' });
      const text = el('text', { class: 'sl-eu__tag-text', 'text-anchor': 'end', y: 4 });
      text.textContent = 'Notre atelier';
      label.append(text);
      inner.append(label);
      g.append(inner);
      points.append(g);
      const b = text.getBBox();
      const bg = el('rect', { class: 'sl-eu__tag-bg', x: b.x - 10, y: b.y - 4, width: b.width + 20, height: b.height + 8, rx: (b.height + 8) / 2 });
      label.insertBefore(bg, text);
    };

    const isVisible = (destination) => inView(project(destination.lat, destination.lng), 22);
    const nextDestination = () => {
      for (let attempt = 0; attempt < 8; attempt += 1) {
        const destination = pickDestination();
        if (destination && isVisible(destination)) return destination;
      }
      return null;
    };

    // Courbe quadratique qui s'arrondit vers le nord.
    const routePath = (from, to) => {
      const dx = to.x - from.x;
      const dy = to.y - from.y;
      let nx = -dy;
      let ny = dx;
      if (ny > 0) {
        nx = -nx;
        ny = -ny;
      }
      const k = (0.22 * Math.hypot(dx, dy)) / (Math.hypot(nx, ny) || 1);
      const cx = (from.x + to.x) / 2 + nx * k;
      const cy = (from.y + to.y) / 2 + ny * k;
      return 'M' + from.x.toFixed(1) + ' ' + from.y.toFixed(1) + 'Q' + cx.toFixed(1) + ' ' + cy.toFixed(1) + ' ' + to.x.toFixed(1) + ' ' + to.y.toFixed(1);
    };

    const ship = (destination, { animate, lifetime }) => {
      const target = project(destination.lat, destination.lng);
      const path = el('path', { class: 'sl-eu__route', d: routePath(workshop, target), 'stroke-width': px(2).toFixed(2) });
      routes.append(path);

      if (animate) {
        const length = path.getTotalLength();
        path.style.strokeDasharray = String(length);
        path.style.strokeDashoffset = String(length);
        path.getBoundingClientRect();
        path.style.transition = 'stroke-dashoffset ' + DRAW_MS + 'ms cubic-bezier(0.4, 0, 0.2, 1), opacity ' + FADE_MS + 'ms ease';
        path.style.strokeDashoffset = '0';
      }

      const point = el('g', { class: 'sl-eu__point', transform: 'translate(' + target.x.toFixed(1) + ' ' + target.y.toFixed(1) + ')' });
      const inner = el('g', { transform: 'scale(' + px(1).toFixed(4) + ')' });
      const flip = target.x > view.x0 + view.w * 0.68;
      const text = el('text', { class: 'sl-eu__point-text', x: flip ? -12 : 12, y: 4, 'text-anchor': flip ? 'end' : 'start' });
      text.textContent = destination.name;
      inner.append(el('circle', { class: 'sl-eu__dot', r: 4 }), text);
      point.append(inner);

      const showPoint = () => {
        points.append(point);
        const b = text.getBBox();
        inner.insertBefore(el('rect', { class: 'sl-eu__point-bg', x: b.x - 8, y: b.y - 3, width: b.width + 16, height: b.height + 6, rx: (b.height + 6) / 2 }), text);
        requestAnimationFrame(() => point.classList.add('is-visible'));
      };
      const hide = () => {
        point.classList.remove('is-visible');
        path.style.opacity = '0';
      };
      const remove = () => {
        path.remove();
        point.remove();
      };

      if (!animate) {
        showPoint();
        return;
      }
      setTimeout(showPoint, DRAW_MS);
      setTimeout(hide, DRAW_MS + lifetime);
      setTimeout(remove, DRAW_MS + lifetime + FADE_MS);
    };

    measure();
    drawWorkshop();
    new ResizeObserver(() => {
      measure();
      drawWorkshop();
    }).observe(svg);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      for (let i = 0; i < 9; i += 1) {
        const destination = nextDestination();
        if (destination) ship(destination, { animate: false, lifetime: 0 });
      }
      return;
    }

    let visible = false;
    new IntersectionObserver(
      ([entry]) => {
        visible = entry.isIntersecting;
      },
      { threshold: 0.1 },
    ).observe(root);

    const tick = () => {
      if (visible && !document.hidden) {
        const destination = nextDestination();
        if (destination) ship(destination, { animate: true, lifetime: LABEL_MS });
      }
      setTimeout(tick, SPAWN_MIN_MS + Math.random() * (SPAWN_MAX_MS - SPAWN_MIN_MS));
    };
    tick();
  };

  document.querySelectorAll('[data-sl-map]').forEach(init);
})();
